module.exports = __webpack_public_path__ + "img/证书框@2x.17693dc0.png";